<template>
  <v-app class="auth-bg">
    <v-container fill-height>
      <v-row justify="center" align="center">
        <v-col cols="12" sm="7" xs="8" md="5" lg="4" xl="3">
          <v-card outlined>
            <a href="/">
              <v-row justify="center" class="text-center px-10 pt-5">
                <v-col>
                  <v-img class="mx-5 mb-0 env-logo" src="../images/rcms_logo.svg"></v-img>
                </v-col>
                <v-col>
                  <v-img class="px-1 mt-n5" src="../images/rcms_title.svg"></v-img>
                </v-col>
              </v-row>
            </a>
            <v-card-text class="text-center">
              <span class="text-center">
                We will send a <strong>Force Logout Link</strong> to your email address.
              </span>

              <v-form class="mt-2" ref="form" v-model="valid" lazy-validation :disabled="disable"
                @keydown.native.enter.prevent="send">
                <v-text-field outlined required label="Email Address" :rules="rules.email" type="email"
                  v-model="form.email" />
                <v-btn class="mb-2 primary" large block :loading="loading" :disabled="disable" @click="send">
                  Send Force Logout Link
                </v-btn>
              </v-form>

              <template v-if="disable">
                <i class="text-center">
                  Click RESEND if you haven't received the email within ({{ seconds }}) seconds.
                </i>
                <v-spacer></v-spacer>
                <v-btn class="mt-2 primary--text" small text :loading="resendLoading" @click="resend">
                  RESEND LINK
                </v-btn>
              </template>

              <div class="mt-4">
                <a href="/login">Back to Login</a>
              </div>
            </v-card-text>
          </v-card>
          <v-card-text class="text-center">
            <span>Copyright © {{ moment().format("YYYY") }} Pylon. All rights reserved.</span>
          </v-card-text>
        </v-col>
      </v-row>
    </v-container>
    <snackbar ref="sysAlert"></snackbar>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    seconds: 60,
    loading: false,
    resendLoading: false,
    disable: false,
    disableResend: false,
    valid: true,
    form: {
      email: '',
    },
    rules: {
      email: [
        (v) => !!v || 'Email address is required',
        (v) => !v || /.+@.+\..+/.test(v) || 'Your email address is incorrect',
      ],
    },
  }),

  methods: {
    send() {
      this.loading = true;
      if (this.rules.email[2]) {
        this.rules.email.splice(2);
      }
      if (this.$refs.form.validate()) {
        axios
          .post('/force-logout/send', this.form)
          .then((res) => {
            this.loading = false;
            this.disable = true;
            this.$refs.sysAlert.content({
              text: res.data.message,
              snackbar: true,
              icon: 'mdi-check-circle',
            });
            this.startTimer();
          })
          .catch((error) => {
            this.loading = false;
            if (error.response.data.errors && error.response.data.errors.email) {
              this.rules.email.push((v) => false || error.response.data.errors.email[0]);
              this.$refs.form.validate();
            } else if (error.response.data.message) {
              this.$refs.sysAlert.content({
                text: error.response.data.message,
                snackbar: true,
                icon: 'mdi-alert-circle',
              });
            }
          });
      } else {
        this.loading = false;
      }
    },

    resend() {
      if (!this.disableResend) return;
      this.resendLoading = true;
      if (this.$refs.form.validate()) {
        axios
          .post('/force-logout/send', this.form)
          .then((res) => {
            this.resendLoading = false;
            this.disableResend = false;
            this.seconds = 60;
            this.startTimer();
            this.$refs.sysAlert.content({
              text: res.data.message,
              snackbar: true,
              icon: 'mdi-check-circle',
            });
          })
          .catch((error) => {
            this.resendLoading = false;
          });
      } else {
        this.resendLoading = false;
      }
    },

    startTimer() {
      this.seconds = 60;
      const interval = setInterval(() => {
        if (this.seconds > 0) {
          this.seconds--;
        } else {
          clearInterval(interval);
          this.disableResend = true;
        }
      }, 1000);
    },
  },

  mounted() {},
};
</script>
